import {Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import {WebsiteService} from '../../services/website.service';
import {Observable, Subscription} from 'rxjs';
import {TermViewModel} from '../../viewModels/term.viewModel';
import {BsModalEventsEmitter} from '../../events/bsModal.events';
import {filter} from 'rxjs/operators';
import {BsModalRef} from 'ngx-bootstrap';

@Component({
    selector: 'app-terms-and-conditions-modal',
    templateUrl: './terms-and-conditions-modal.component.html',
    styleUrls: ['./terms-and-conditions-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TermsAndConditionsModalComponent implements OnInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    loading: boolean = true;
    termsAndConditions: TermViewModel;
    subscriptions: Subscription[] = [];

    constructor(
        private readonly websiteService: WebsiteService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly changeDetectorRef: ChangeDetectorRef,
        public readonly bsModalRef: BsModalRef
    ) {
    }

    ngOnInit() {
        this.subscriptions.push(
            this.bsModalEventsEmitter.bsModalStateChanged$.pipe(filter(bsModalRef => bsModalRef === this.bsModalRef)).subscribe(() => {
                this.websiteService.getTermsAndConditions().subscribe(termsAndConditions => {
                    this.termsAndConditions = termsAndConditions;
                    this.loading = false;
                    this.changeDetectorRef.markForCheck();
                });
            })
        );
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }
}
